





















































































































































































































































































































































import SearchBuilder from "@/builder/SearchBuilder";
import { debounceProcess } from "@/helpers/debounce";
import { useContactData } from "@/hooks/contact";
import { useFindMasterType } from "@/hooks/master-type";
import { useTax } from "@/hooks/tax";
import useCurrency from "@/hooks/useCurrency";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { settingsServices } from "@/services/settings.service";
import { StorageStatePreference } from "@/store/models/Preference.model";
import Vue from "vue";
import { mapActions, mapState } from "vuex";

export default Vue.extend({
  name: "PreferenceFeature",
  data() {
    this.onSearchCurrency = debounceProcess(this.onSearchCurrency, 500);
    this.onSearchSalesTax = debounceProcess(this.onSearchSalesTax, 500);
    this.onSearchPurchaseTax = debounceProcess(this.onSearchPurchaseTax, 500);
    this.onSearchEmployee = debounceProcess(this.onSearchEmployee, 500);
    this.onSearchPurchaseInclusiveTax = debounceProcess(
      this.onSearchPurchaseInclusiveTax
    );
    this.onSearchSalesInclusiveTax = debounceProcess(
      this.onSearchSalesInclusiveTax
    );
    return {
      booleanOptions: [
        {
          label: this.$t("lbl_yes"),
          value: "true",
        },
        {
          label: this.$t("lbl_no"),
          value: "false",
        },
      ],
      currencyOptions: [] as Option[],
      decimalFormatOptions: [] as Option[],
      decimalPointOptions: [] as Option[],
      discountOptions: [] as Option[],
      salesTaxOptions: [] as Option[],
      purchaseTaxOptions: [] as Option[],
      purchaseInclusiveTaxOptions: [] as Option[],
      salesInclusiveTaxOptions: [] as Option[],
      employeeOptions: [] as Option[],
      loading: {
        currency: false,
        decimalFormat: false,
        decimalPoint: false,
        discount: false,
        salesTax: false,
        purchaseTax: false,
        purchaseInclusiveTax: false,
        salesInclusiveTax: false,
        employee: false,
      },
    };
  },
  computed: {
    ...mapState({
      state: (st: any) => st.preferenceStore as StorageStatePreference,
    }),
  },
  mounted(): void {
    this.initPreferenceFormFeature();
    this.fetchCurrencyList();
    this.fetchDecimalFormatList();
    this.fetchDecimalPointList();
    this.fetchDiscountList();
    this.getPurchaseTaxOptions();
    this.getSalesTaxOptions();
    this.fetchEmployeeList();
  },
  methods: {
    ...mapActions({
      updatePreferenceFeature: "preferenceStore/updatePreferenceFeature",
      initPreferenceFormFeature: "preferenceStore/initPreferenceFormFeature",
    }),
    async getPurchaseTaxOptions() {
      const options = await this.fetchPurchaseTaxRateList();
      this.purchaseTaxOptions = [...options];
      this.purchaseInclusiveTaxOptions = [...options];
    },
    async getSalesTaxOptions() {
      const options = await this.fetchSalesTaxRateList();
      this.salesTaxOptions = [...options];
      this.salesInclusiveTaxOptions = [...options];
    },
    async fetchEmployeeList(search?: string) {
      const { findAllEmployee } = useContactData();
      const params = new RequestQueryParams();
      params.search = search ?? "";
      params.sorts = "firstName:asc";
      try {
        this.loading.employee = true;
        const response = await findAllEmployee(params);
        this.employeeOptions = response.data.map(item => ({
          key: item.id,
          label: item.employeePosition,
          value: item.id,
        }));
      } finally {
        this.loading.employee = false;
      }
    },
    async onSearchEmployee(value?: string) {
      const { filterBy } = useContactData();
      const search = filterBy({
        firstName: value ?? "",
        lastName: value ?? "",
      });
      this.fetchEmployeeList(search);
    },
    async onSearchSalesTax(value?: string) {
      try {
        this.loading.salesTax = true;
        const options = await this.fetchSalesTaxRateList(value);
        this.salesTaxOptions = options;
      } catch {
        this.salesTaxOptions = [];
      } finally {
        this.loading.salesTax = false;
      }
    },
    async onSearchPurchaseTax(value?: string) {
      try {
        this.loading.purchaseTax = true;
        const options = await this.fetchPurchaseTaxRateList(value);
        this.purchaseTaxOptions = options;
      } finally {
        this.loading.purchaseTax = false;
      }
    },
    async fetchSalesTaxRateList(search?: string) {
      const { findAllVatOut, toOptions } = useTax();
      try {
        const response = await findAllVatOut(search);
        return toOptions(response.data);
      } catch {
        return [];
      }
    },
    async fetchPurchaseTaxRateList(search?: string) {
      const { findAllVatIn, toOptions } = useTax();
      try {
        const response = await findAllVatIn(search);
        return toOptions(response.data);
      } catch {
        return [];
      }
    },
    async fetchDiscountList() {
      try {
        this.loading.discount = true;
        const response = await useFindMasterType("DISCOUNT_CALCULATION");
        this.discountOptions = response.map(dt => ({
          key: dt.id,
          label: dt.value,
          value: dt.id,
        }));
      } finally {
        this.loading.discount = false;
      }
    },
    async fetchDecimalPointList() {
      try {
        this.loading.decimalPoint = true;
        const response = await useFindMasterType("DECIMAL_POINT");
        this.decimalPointOptions = response.map(dt => ({
          key: dt.id,
          label: dt.value,
          value: dt.value,
        }));
      } finally {
        this.loading.decimalPoint = false;
      }
    },
    async fetchDecimalFormatList() {
      try {
        this.loading.decimalFormat = true;
        const response = await useFindMasterType("DECIMAL_FORMAT");
        this.decimalFormatOptions = response.map(dt => ({
          key: dt.id,
          label: dt.value,
          value: dt.id,
        }));
      } finally {
        this.loading.decimalFormat = false;
      }
    },
    onSave() {
      this.updatePreferenceFeature();
    },
    async fetchCurrencyList(): Promise<void> {
      const { toOptionsNew } = useCurrency();
      try {
        this.loading.currency = true;
        const response = await settingsServices.getListMasterCurrency();
        this.currencyOptions = toOptionsNew(response.data);
      } finally {
        this.loading.currency = false;
      }
    },
    onSearchCurrency(value: string | null): void {
      const { toOptionsNew } = useCurrency();
      let search = "";
      if (value) {
        search = new SearchBuilder()
          .push(["currencyCode", value], { like: "both" })
          .or()
          .push(["description", value], { like: "both" })
          .build();
      }
      this.loading.currency = true;
      settingsServices
        .getListMasterCurrency({ search: search ?? undefined })
        .then(({ data }) => {
          this.currencyOptions = toOptionsNew(data);
        })
        .finally(() => {
          this.loading.currency = false;
        });
    },
    async onSearchPurchaseInclusiveTax(val?: string) {
      try {
        this.loading.purchaseInclusiveTax = true;
        const options = await this.fetchPurchaseTaxRateList(val);
        this.purchaseInclusiveTaxOptions = options;
      } finally {
        this.loading.purchaseInclusiveTax = false;
      }
    },
    async onSearchSalesInclusiveTax(val?: string) {
      try {
        this.loading.salesInclusiveTax = true;
        const options = await this.fetchSalesTaxRateList(val);
        this.salesInclusiveTaxOptions = options;
      } finally {
        this.loading.salesInclusiveTax = false;
      }
    },
  },
});
